module.exports = __webpack_public_path__ + "img/violet_012.203efcb4.png";